/* eslint-disable max-lines */
import { CustomController } from '@/components/form/controller';
import { InputType } from '@/components/form/customSelect';
import { ImageInput } from '@/components/form/imageUploading';
import { FormType } from '@/components/form/types';
import { CommonType } from '@/stores/slices/amenity/type';
import { Box } from '@mui/material';
import _ from 'lodash';
import { MuiColorInput } from 'mui-color-input';
import { SetStateAction, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CustomButton, { CustomButtonType } from 'src/components/common/Button';
import PopUp from 'src/components/common/Popup';
import { OneInputContainer } from 'src/components/floor/components';
import { Label } from '@/components/form/input';
export interface CategoryPopupProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (formdata: Omit<CommonType, 'id'>) => void;
  data?: CommonType;
}

export function CategoryPopup({
  open,
  onClose,
  onSubmit,
  data,
}: CategoryPopupProps) {
  const categoryForm = useForm<Omit<CommonType, 'id'>>({
    defaultValues: _.omit(data, ['id']),
  });

  const [color, setColor] = useState('#ffffff');
  const handleChangeColor = (newColor: SetStateAction<string>) => {
    setColor(newColor);
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = categoryForm;

  const { t, i18n } = useTranslation();

  const submitForm = async (formDt: any) => {
    onSubmit({
      ...formDt,
      icon: Array.isArray(formDt?.icon)
        ? formDt?.icon[0]?.data_url ?? null
        : formDt?.icon ?? null,
      color: color,
    });
  };

  useEffect(() => {
    if (data) {
      reset(_.omit(data, ['id']));
      setColor(data.color || '#ffffff');
    } else {
      reset({
        name: '',
        color: '',
        icon: '',
      });
      setColor('#ffffff');
    }
  }, [data, reset, open]);

  return (
    <PopUp
      title={data ? t('Edit Category') : t('Add Category')}
      onClose={onClose}
      open={open}
    >
      <Box component="form" onSubmit={handleSubmit(submitForm)}>
        <OneInputContainer>
          <CustomController
            controller={control}
            name="name"
            label={t('Name')}
            isRequired
            error={errors?.name?.message}
            formType={FormType.INPUT}
          />
        </OneInputContainer>
        <Label>Color {true && <span>*</span>}</Label>
        <OneInputContainer>
          <MuiColorInput
            name="color"
            format="hex"
            value={color}
            onChange={handleChangeColor}
            sx={{
              marginBottom: '16px',
              backgroundColor: 'white',
            }}
          />
        </OneInputContainer>
        <Box component="div" mb={3}>
          <Controller
            control={control}
            name="icon"
            rules={{
              required: t('This field is required'),
            }}
            render={({ field }) => {
              const { value, onChange } = field;
              return (
                <ImageInput
                  label={t('Icon')}
                  title={t('Drag an image here or click “Upload” below')}
                  width={120}
                  height={120}
                  inputType={InputType.POP_UP}
                  onUpload={onChange}
                  value={value ? [value] : []}
                  isRequired
                  errorMessage={errors?.icon?.message}
                />
              );
            }}
          />
        </Box>
        <Box
          component="div"
          sx={{
            margin: '40px 0 0',
            display: 'grid',
            gridTemplateColumns:
              i18n.resolvedLanguage === 'en' ? '70px 70px' : '120px 70px',
            justifyContent: 'flex-end',
            gridGap: '20px',
          }}
        >
          <CustomButton
            buttonType={CustomButtonType.WHITE_BG}
            title={t(`Cancel`)}
            onClick={onClose}
          />
          <CustomButton
            type="submit"
            buttonType={CustomButtonType.NO_ICON}
            title={t(`Submit`)}
          />
        </Box>
      </Box>
    </PopUp>
  );
}
